import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';

export default function Navperfil() {
  const { t } = useTranslation();
  return (
    <nav>
      <ul>
        <li><Link id="timeline" className="mnu" to="/perfil">{ t('pages.includes.navProfile.profile') }</Link></li>
        <li><Link id="classificados" className="mnu" to="/publicacoes">{ t('pages.includes.navProfile.publications') }</Link></li>
        <li><Link id="classificados" className="mnu" to="/meus-anuncios">{ t('pages.includes.navProfile.myAdverts') }</Link></li>
        {/* <li><Link id="BEZERRO" className="mnu" to="/timeline">#BEZERRO</Link></li>
        <li><Link id="BEZERRA" className="mnu" to="/timeline">#BEZERRA</Link></li>
        <li><Link id="BOI_GORDO_CEPEA" className="mnu" to="/timeline">#BOI_GORDO_CEPEA</Link></li>
        <li><Link id="NOVILHA_EU_HILTON" className="mnu" to="/timeline">#NOVILHA_EU_HILTON</Link></li>
        <li><Link id="NOVILHA_EUROPA" className="mnu" to="/timeline">#NOVILHA_EUROPA</Link></li>
        <li><Link id="NOVILHA_GORDA" className="mnu" to="/timeline">#NOVILHA_GORDA</Link></li>
        <li><Link id="NOVILHA_GORDA_CEPEA" className="mnu" to="/timeline">#NOVILHA_GORDA_CEPEA</Link></li> */}
      </ul>
    </nav>
  )
}